


// Handles custom font dropdown selection
function setupCustomFontDropdowns() {
    const customSelects = document.querySelectorAll('.product .custom-select');

    customSelects.forEach(select => {
        const trigger = select.querySelector('.custom-select__trigger');
        const options = select.querySelectorAll('.custom-option');
        const hiddenInput = select.parentElement.querySelector('.font-selection-input');
        const previews = document.querySelectorAll('.personalized-message-preview-text');
        trigger.addEventListener('click', () => {
            closeAllCustomSelects(select);
            select.classList.add('open');
        });

        options.forEach(option => {
            let fontInput = document.getElementById('personalized-font-input');
            fontInput.value = 'Mermaid';
            option.addEventListener('click', () => {
                fontInput.removeAttribute('disabled');
                trigger.querySelector('span').textContent = option.textContent;
                
                const currentSelected = select.querySelector('.custom-option.selected');
                if (currentSelected) currentSelected.classList.remove('selected');
                option.classList.add('selected');
                fontInput.value = option.textContent;
                const selectedFont = option.dataset.value;
                if (hiddenInput) hiddenInput.value = selectedFont;
                if (previews.length > 0) {
                    previews.forEach(preview => {
                        preview.style.fontFamily = selectedFont;
                    });
                }

                select.classList.remove('open');
            });
        });
    });
}

// Handles personalized message input field
function setupPersonalizedMessageInput() {
    const input = document.querySelector('.personalised-message-input-field');
    const previews = document.querySelectorAll('.personalized-message-preview-text');
    const maxChars = parseInt(input?.dataset.maxChars) || 80;

    if (!input || previews.length === 0) return;

    input.addEventListener('input', function (e) {
        document.getElementById('personalized-text-input').removeAttribute('disabled');
        if (e.data && this.value.length >= maxChars) {
            e.preventDefault();
            triggerInputError(this);
        }
        let message = document.getElementById('personalized-text-input');
        message.value = input.value;

        // Switch to preview image when user starts typing
        if (this.value.length === 1) {
            switchToPreviewImage();
        }
    });

    input.addEventListener('input', function () {
        let text = this.value;
        if (text.length > maxChars) {
            text = text.substring(0, maxChars);
            this.value = text;

        }
        if (text.length < maxChars) {
            this.classList.remove('error');
        }
        updatePreviewText(previews, text);
    });

    input.addEventListener('paste', function (e) {
        const pastedText = (e.clipboardData || window.clipboardData).getData('text');
        const currentLength = this.value.length;
        const selectionLength = this.selectionEnd - this.selectionStart;
        const finalLength = currentLength - selectionLength + pastedText.length;

        if (finalLength > maxChars) {
            e.preventDefault();
            triggerInputError(this);
        }
    });

    updatePreviewText(previews, input.value.substring(0, maxChars));
}

// Switches to the image tagged with "preview" in alt text
function switchToPreviewImage() {
    // Get current variant
    const variantPicker = document.querySelector('variant-selects [data-selected-variant]');
    if (!variantPicker) return;
    
    const variant = JSON.parse(variantPicker.innerHTML);
    const variantName = variant.title.trim().toLowerCase();

    // Find the preview image for current variant
    const carouselItems = document.querySelectorAll('.product__media-list li.product__media-item');
    let previewImageId = null;

    carouselItems.forEach(item => {
        const img = item.querySelector('img');
        const altText = img?.getAttribute('alt')?.trim()?.toLowerCase();
        
        // Check if image matches variant AND has "preview" tag
        if (altText && altText.includes(variantName) && altText.includes('preview')) {
            previewImageId = item.getAttribute('data-media-id');
        }
    });

    // Switch to that image if found
    if (previewImageId) {
        const mediaGallery = document.querySelector('media-gallery');
        if (mediaGallery && mediaGallery.setActiveMedia) {
            mediaGallery.setActiveMedia(previewImageId, false);
        }
    }
}

// Handles color input changes
function setupColorPicker() {
    const colorInputs = document.querySelectorAll('input[name="personalised-msg-color"]');
    const previews = document.querySelectorAll('.personalized-message-preview-text');

    colorInputs.forEach(input => {
        document.getElementById('personalized-color-input').value = '#ADD8E6';
        input.addEventListener('change', function () {
            document.getElementById('personalized-color-input').removeAttribute('disabled');
            const color = this.value;
            if (previews.length > 0) {
                previews.forEach(preview => {
                    preview.style.color = color;
                    let colorr = document.getElementById('personalized-color-input');
                    colorr.value = color;

                });
            }
        });
    });
}

// Closes all open dropdowns on outside click
function setupOutsideClickToCloseDropdowns() {
    document.addEventListener('click', (e) => {
        if (!e.target.closest('.custom-select')) {
            closeAllCustomSelects();
        }
    });
}

// Close all selects except one
function closeAllCustomSelects(currentSelect = null) {
    const selects = document.querySelectorAll('.custom-select');
    selects.forEach(select => {
        if (select !== currentSelect) {
            select.classList.remove('open');
        }
    });
}

// Updates the preview text styling and content
function updatePreviewText(previews, text) {
    const color = document.querySelector('input[name="personalised-msg-color"]:checked')?.value;
    const font = document.querySelector('.font-selection-input')?.value || 'Mermaid';

    text = text.replace(/\n/g, '<br>');
    
    // Handle both single element and multiple elements
    if (previews instanceof NodeList) {
        previews.forEach(preview => {
            preview.innerHTML = text;
            preview.style.fontFamily = font;
            preview.style.color = color;
        });
    } else {
        previews.innerHTML = text;
        previews.style.fontFamily = font;
        previews.style.color = color;
    }
}

// Triggers error animation on input
function triggerInputError(input) {
    input.classList.remove('error');
    void input.offsetWidth;
    input.classList.add('error');
}

// Applies initial font and color styles
function applyInitialPreviewStyles() {
    const previews = document.querySelectorAll('.personalized-message-preview-text');
    const font = document.querySelector('.font-selection-input')?.value || 'Mermaid';
    const color = document.querySelector('input[name="personalised-msg-color"]:checked')?.value;

    if (previews.length > 0) {
        previews.forEach(preview => {
            preview.style.fontFamily = font;
            preview.style.color = color;
        });
    }
}

// Clears personalized message input and preview fields
function clearPersonalizedMessageFields() {
    const input = document.querySelector('.personalised-message-input-field');
    const previews = document.querySelectorAll('.personalized-message-preview-text');
    const hiddenInput = document.getElementById('personalized-text-input');

    if (input) {
        input.value = '';
    }

    if (hiddenInput) {
        hiddenInput.value = '';
        hiddenInput.setAttribute('disabled', 'disabled');
    }

    if (previews.length > 0) {
        previews.forEach(preview => {
            preview.innerHTML = '';
        });
    }
}

function setupSlideChangeListeners() {
    const hasPersonalizedFields = document.querySelector('.personalised-message-input-field') !== null;
    if (!hasPersonalizedFields) return;
    const viewer = document.querySelector('[id^="GalleryViewer"]');
    if (viewer) {
        viewer.addEventListener('slideChanged', function() {
            clearPersonalizedMessageFields();
        });
    }
    const thumbnailsContainer = document.querySelector('[id^="GalleryThumbnails"]');
    if (thumbnailsContainer) {
        thumbnailsContainer.addEventListener('click', function(e) {
            const thumbnailItem = e.target.closest('[data-target]');
            if (thumbnailItem) {
                clearPersonalizedMessageFields();
            }
        });
    }
}

window.initializePersonalizedMessageUI = function () {
    setupCustomFontDropdowns();
    setupPersonalizedMessageInput();
    setupColorPicker();
    setupOutsideClickToCloseDropdowns();
    applyInitialPreviewStyles();
    setupSlideChangeListeners();
}

window.initializePersonalizedMessageUI();